import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { Container, Header, Grid } from 'semantic-ui-react';
import { PricingForm } from '../forms';
import { withAuth } from '../auth';
import { withPricing } from '../hoc';
import { withPageViewTracking, withAnalytics } from '../analytics';
import { PageHeader, Wrappers } from '../components';

const PricingHelper = props => {
  return (
    <Wrappers.Layout menu>
      <Container as="main">
        <PageHeader overlap>
          <Header as="h1" data-qa="pricing-helper-header">
            <FormattedMessage
              id="title.pricing"
              description="Pricing Helper page title"
              defaultMessage="Pricing Helper"
            />
          </Header>
          <p>
            <FormattedMessage
              id="description.pricing"
              defaultMessage="Start with a brand, selection options and enter discounts to get the most recent product pricing!"
            />
          </p>
        </PageHeader>

        <Grid>
          <Grid.Column>
            <PricingForm {...props} />
          </Grid.Column>
        </Grid>
      </Container>
    </Wrappers.Layout>
  );
};

PricingHelper.propTypes = {
  // from injectIntl
  intl: intlShape.isRequired,
  // from withAnalytics
  analytics: PropTypes.object.isRequired,
  // from withPricing run down to the PricingForm
  fields: PropTypes.arrayOf(PropTypes.object),
  selected: PropTypes.object,
  setInitialState: PropTypes.func.isRequired,
  handleOnChange: PropTypes.func.isRequired
};

export default withPricing(
  withPageViewTracking()(withAnalytics(injectIntl(withAuth(PricingHelper))))
);
